module.exports = __webpack_public_path__ + "static/media/contentTitle@2x.a3b73935.png";